import { useEffect, useState, useSyncExternalStore } from 'react';
import { captureStore } from './store';
import { PlaycastGamepadDevice } from '@playcastdotio/CoreTypes';
import { convertGamepads } from './convertGamepads';

export const GamepadMessages = () => {
  const [latest, setLatest] = useState<string>('');
  const event = useSyncExternalStore(captureStore.subscribeEvent, captureStore.getEvent);

  useEffect(() => {
    if (event?.type === 'gamepad') {
      const e = event as CustomEvent;
      const capture = e.detail as (Gamepad | null)[];
      const state: PlaycastGamepadDevice[] = convertGamepads(capture.filter((x) => x) as Gamepad[]);
      setLatest(JSON.stringify(state, null, 4));
    }
  }, [event]);

  return <pre>{latest}</pre>;
};
